import { render, staticRenderFns } from "./OsStatisticsCardParticipantsPerCustomer.vue?vue&type=template&id=15074e6b&scoped=true"
import script from "./OsStatisticsCardParticipantsPerCustomer.vue?vue&type=script&lang=ts"
export * from "./OsStatisticsCardParticipantsPerCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15074e6b",
  null
  
)

export default component.exports